/**
 * @description 绘制实例 20260516 重构绘制核心算法 - 绘制类的相关工具函数
 * @author 1982392655@qq.com ~朴:shu
 * @time 20260516
 */

import { luckysheetdefaultFont, luckysheetdefaultstyle } from "../controllers/constant";
import { highlightCellCtrl } from "../controllers/highlightCellCtrl";
import { isInlineStringCell } from "../controllers/inlineString";
import menuButton from "../controllers/menuButton";
import { luckysheet_searcharray } from "../controllers/sheetSearch";
import { visualAidCtrl } from "../controllers/visualAidCtrl";
import { getCellTextInfo, getMeasureText } from "../global/getRowlen";
import method from "../global/method";
import { isRealNull } from "../global/validate";
import Store from "../store";
import { chatatABC, getObjType } from "./util";

/**
 * @description 根据传入的 mycanvas 确定最终绘制上下文
 */
function parseDrawContext(mycanvas) {
    // // 默认使用表格 canvas 上下文
    if (mycanvas == null) return $("#luckysheetTableContent").get(0).getContext("2d");

    // 如果传递的是 canvas 元素，直接使用该元素的上下文
    if (getObjType(mycanvas) === "object") {
        try {
            return mycanvas.get(0).getContext("2d");
        } catch (err) {
            return mycanvas;
        }
    }

    // 其他类型，则认定是 string 类型，尝试获取对应的 canvas 元素
    return $("#" + mycanvas)
        .get(0)
        .getContext("2d");
}

/**
 * @description 初始化画布
 */
function initCanvas(ctx, drawParams) {
    const { scrollHeight, scrollWidth, fill_row_ed, fill_col_ed, offsetLeft, offsetTop, devicePixelRatio, isPrint = false } = drawParams;
    ctx.save();
    ctx.scale(devicePixelRatio, devicePixelRatio);
    if (isPrint) ctx.translate(0.75, 0.75); // 这个是为了解决左上边框不显示及打印时，绘制边框不显示问题
    ctx.clearRect(0, 0, Store.luckysheetTableContentHW[0], Store.luckysheetTableContentHW[1]);
    ctx.fillStyle = "transparent";
    ctx.fillRect(offsetLeft, offsetTop, fill_col_ed - scrollWidth, fill_row_ed - scrollHeight);
    ctx.font = luckysheetdefaultFont();
    ctx.fillStyle = luckysheetdefaultstyle.fillStyle;
}

/**
 * @description 获取表格渲染区域 起止行列下标
 */
function getRenderAreaRange(drawParams) {
    const { scrollHeight, scrollWidth, drawHeight, drawWidth, rowOffsetCell, columnOffsetCell } = drawParams;
    let dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed;

    dataset_row_st = luckysheet_searcharray(Store.visibledatarow, scrollHeight);
    dataset_row_ed = luckysheet_searcharray(Store.visibledatarow, scrollHeight + drawHeight);

    if (dataset_row_st == -1) {
        dataset_row_st = 0;
    }

    dataset_row_st += rowOffsetCell;

    if (dataset_row_ed == -1) {
        dataset_row_ed = Store.visibledatarow.length - 1;
    }

    dataset_row_ed += rowOffsetCell;

    if (dataset_row_ed >= Store.visibledatarow.length) {
        dataset_row_ed = Store.visibledatarow.length - 1;
    }

    dataset_col_st = luckysheet_searcharray(Store.visibledatacolumn, scrollWidth);
    dataset_col_ed = luckysheet_searcharray(Store.visibledatacolumn, scrollWidth + drawWidth);

    if (dataset_col_st == -1) {
        dataset_col_st = 0;
    }

    dataset_col_st += columnOffsetCell;

    if (dataset_col_ed == -1) {
        dataset_col_ed = Store.visibledatacolumn.length - 1;
    }

    dataset_col_ed += columnOffsetCell;

    if (dataset_col_ed >= Store.visibledatacolumn.length) {
        dataset_col_ed = Store.visibledatacolumn.length - 1;
    }

    //表格渲染区域 起止行列坐标
    let fill_row_st, fill_row_ed, fill_col_st, fill_col_ed;

    if (dataset_row_st == 0) {
        fill_row_st = 0;
    } else {
        fill_row_st = Store.visibledatarow[dataset_row_st - 1];
    }

    fill_row_ed = Store.visibledatarow[dataset_row_ed];

    if (dataset_col_st == 0) {
        fill_col_st = 0;
    } else {
        fill_col_st = Store.visibledatacolumn[dataset_col_st - 1];
    }

    fill_col_ed = Store.visibledatacolumn[dataset_col_ed];

    return {
        fill_row_st,
        fill_row_ed,
        fill_col_st,
        fill_col_ed,
        dataset_row_st,
        dataset_row_ed,
        dataset_col_st,
        dataset_col_ed,
    };
}

/**
 * @description 解析单元格数据 cellupdate borderOffset
 */
function parseCellData(drawParams) {
    const { dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed, scrollHeight, scrollWidth } = drawParams;

    let cellupdate = [];
    let borderOffset = {};
    let mergeCache = {};

    for (let r = dataset_row_st; r <= dataset_row_ed; r++) {
        let start_r;
        if (r == 0) {
            start_r = -scrollHeight - 1;
        } else {
            start_r = Store.visibledatarow[r - 1] - scrollHeight - 1;
        }

        let end_r = Store.visibledatarow[r] - scrollHeight;

        if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) {
            continue;
        }

        for (let c = dataset_col_st; c <= dataset_col_ed; c++) {
            let start_c;
            if (c == 0) {
                start_c = -scrollWidth;
            } else {
                start_c = Store.visibledatacolumn[c - 1] - scrollWidth;
            }

            let end_c = Store.visibledatacolumn[c] - scrollWidth;

            if (Store.config["colhidden"] != null && Store.config["colhidden"][c] != null) {
                continue;
            }

            // 从这里开始 就是行列计算规则

            let firstcolumnlen = Store.defaultcollen;
            if (Store.config["columnlen"] != null && Store.config["columnlen"][c] != null) {
                firstcolumnlen = Store.config["columnlen"][c];
            }

            if (Store.flowdata[r] != null && Store.flowdata[r][c] != null) {
                let value = Store.flowdata[r][c];

                if (getObjType(value) == "object" && "mc" in value) {
                    borderOffset[r + "_" + c] = {
                        start_r: start_r,
                        start_c: start_c,
                        end_r: end_r,
                        end_c: end_c,
                    };

                    if ("rs" in value["mc"]) {
                        let key = "r" + r + "c" + c;
                        mergeCache[key] = cellupdate.length;
                    } else {
                        let key = "r" + value["mc"].r + "c" + value["mc"].c;
                        let margeMain = cellupdate[mergeCache[key]];

                        if (margeMain == null) {
                            mergeCache[key] = cellupdate.length;
                            cellupdate.push({
                                r: r,
                                c: c,
                                start_c: start_c,
                                start_r: start_r,
                                end_r: end_r,
                                end_c: end_c,
                                firstcolumnlen: firstcolumnlen,
                            });
                        } else {
                            if (margeMain.c == c) {
                                margeMain.end_r += end_r - start_r - 1;
                            }

                            if (margeMain.r == r) {
                                margeMain.end_c += end_c - start_c;
                                margeMain.firstcolumnlen += firstcolumnlen;
                            }
                        }

                        continue;
                    }
                }
            }

            cellupdate.push({
                r: r,
                c: c,
                start_r: start_r,
                start_c: start_c,
                end_r: end_r,
                end_c: end_c,
                firstcolumnlen: firstcolumnlen,
            });
            borderOffset[r + "_" + c] = {
                start_r: start_r,
                start_c: start_c,
                end_r: end_r,
                end_c: end_c,
            };
        }
    }

    return {
        cellupdate,
        borderOffset,
        mergeCache,
    };
}

/**
 * @description 检查单元格是否在溢出单元格的渲染范围内
 */
function cellOverflow_colIn(map, r, c, col_st, col_ed) {
    let colIn = false, //此单元格 是否在 某个溢出单元格的渲染范围
        colLast = false, //此单元格 是否是 某个溢出单元格的渲染范围的最后一列
        rowIndex, //溢出单元格 行下标
        colIndex, //溢出单元格 列下标
        stc,
        edc;

    for (let rkey in map) {
        for (let ckey in map[rkey]) {
            rowIndex = rkey;
            colIndex = ckey;
            // rowIndex = key.substr(0, key.indexOf('_'));
            // colIndex = key.substr(key.indexOf('_') + 1);
            let mapItem = map[rkey][ckey];
            stc = mapItem.stc;
            edc = mapItem.edc;

            if (rowIndex == r) {
                if (c >= stc && c <= edc) {
                    colIn = true;

                    if (c == edc || c == col_ed) {
                        colLast = true;
                        break;
                    }
                }
            }
        }

        if (colLast) {
            break;
        }
    }

    return {
        colIn: colIn,
        colLast: colLast,
        rowIndex: rowIndex,
        colIndex: colIndex,
        stc: stc,
        edc: edc,
    };
}

/**
 * @description 获取表格渲染范围 溢出单元格
 */
function getCellOverflowMap(canvas, drawParams) {
    const row_st = drawParams.dataset_row_st;
    const row_end = drawParams.dataset_row_ed;
    const col_st = drawParams.dataset_col_st;
    const col_ed = drawParams.dataset_col_ed;

    let map = {};

    let data = Store.flowdata;

    for (let r = row_st; r <= row_end; r++) {
        if (data[r] == null) {
            continue;
        }

        if (Store.cellOverflowMapCache[r] != null) {
            map[r] = Store.cellOverflowMapCache[r];
            continue;
        }

        let hasCellOver = false;

        for (let c = 0; c < data[r].length; c++) {
            let cell = data[r][c];

            // if(Store.cellOverflowMapCache[r + '_' + c]!=null){
            //     map[r + '_' + c] = Store.cellOverflowMapCache[r + '_' + c];
            //     continue;
            // }

            if (Store.config["colhidden"] != null && Store.config["colhidden"][c] != null) {
                continue;
            }

            if (cell != null && (!isRealNull(cell.v) || isInlineStringCell(cell)) && cell.mc == null && cell.tb == "1") {
                //水平对齐
                let horizonAlign = menuButton.checkstatus(data, r, c, "ht");

                let textMetricsObj = getCellTextInfo(cell, canvas, {
                    r: r,
                    c: c,
                });
                let textMetrics = 0;
                if (textMetricsObj != null) {
                    textMetrics = textMetricsObj.textWidthAll;
                }

                //canvas.measureText(value).width;

                let start_c = c - 1 < 0 ? 0 : Store.visibledatacolumn[c - 1];
                let end_c = Store.visibledatacolumn[c];

                let stc, edc;

                if (end_c - start_c < textMetrics) {
                    if (horizonAlign == "0") {
                        //居中对齐
                        let trace_forward = cellOverflow_trace(r, c, c - 1, "forward", horizonAlign, textMetrics);
                        let trace_backward = cellOverflow_trace(r, c, c + 1, "backward", horizonAlign, textMetrics);

                        if (trace_forward.success) {
                            stc = trace_forward.c;
                        } else {
                            stc = trace_forward.c + 1;
                        }

                        if (trace_backward.success) {
                            edc = trace_backward.c;
                        } else {
                            edc = trace_backward.c - 1;
                        }
                    } else if (horizonAlign == "1") {
                        //左对齐
                        let trace = cellOverflow_trace(r, c, c + 1, "backward", horizonAlign, textMetrics);
                        stc = c;

                        if (trace.success) {
                            edc = trace.c;
                        } else {
                            edc = trace.c - 1;
                        }
                    } else if (horizonAlign == "2") {
                        //右对齐
                        let trace = cellOverflow_trace(r, c, c - 1, "forward", horizonAlign, textMetrics);
                        edc = c;

                        if (trace.success) {
                            stc = trace.c;
                        } else {
                            stc = trace.c + 1;
                        }
                    }
                } else {
                    stc = c;
                    edc = c;
                }

                // if(((stc >= col_st && stc <= col_ed) || (edc >= col_st && edc <= col_ed)) && stc < edc){
                if ((stc <= col_ed || edc >= col_st) && stc < edc) {
                    let item = {
                        r: r,
                        stc: stc,
                        edc: edc,
                    };

                    if (map[r] == null) {
                        map[r] = {};
                    }

                    map[r][c] = item;

                    // Store.cellOverflowMapCache[r + '_' + c] = item;

                    hasCellOver = true;
                }
            }
        }

        if (hasCellOver) {
            Store.cellOverflowMapCache[r] = map[r];
        }
    }
    return map;
}

function cellOverflow_trace(r, curC, traceC, traceDir, horizonAlign, textMetrics) {
    let data = Store.flowdata;

    //追溯单元格列超出数组范围 则追溯终止
    if (traceDir == "forward" && traceC < 0) {
        return {
            success: false,
            r: r,
            c: traceC,
        };
    }

    if (traceDir == "backward" && traceC > data[r].length - 1) {
        return {
            success: false,
            r: r,
            c: traceC,
        };
    }

    //追溯单元格是 非空单元格或合并单元格 则追溯终止
    let cell = data[r][traceC];
    if (cell != null && (!isRealNull(cell.v) || cell.mc != null)) {
        return {
            success: false,
            r: r,
            c: traceC,
        };
    }

    let start_curC = curC - 1 < 0 ? 0 : Store.visibledatacolumn[curC - 1];
    let end_curC = Store.visibledatacolumn[curC];

    let w = textMetrics - (end_curC - start_curC);

    if (horizonAlign == "0") {
        //居中对齐
        start_curC -= w / 2;
        end_curC += w / 2;
    } else if (horizonAlign == "1") {
        //左对齐
        end_curC += w;
    } else if (horizonAlign == "2") {
        //右对齐
        start_curC -= w;
    }

    let start_traceC = traceC - 1 < 0 ? 0 : Store.visibledatacolumn[traceC - 1];
    let end_traceC = Store.visibledatacolumn[traceC];

    if (traceDir == "forward") {
        if (start_curC < start_traceC) {
            return cellOverflow_trace(r, curC, traceC - 1, traceDir, horizonAlign, textMetrics);
        } else if (start_curC < end_traceC) {
            return {
                success: true,
                r: r,
                c: traceC,
            };
        } else {
            return {
                success: false,
                r: r,
                c: traceC,
            };
        }
    }

    if (traceDir == "backward") {
        if (end_curC > end_traceC) {
            return cellOverflow_trace(r, curC, traceC + 1, traceDir, horizonAlign, textMetrics);
        } else if (end_curC > start_traceC) {
            return {
                success: true,
                r: r,
                c: traceC,
            };
        } else {
            return {
                success: false,
                r: r,
                c: traceC,
            };
        }
    }
}

/**
 * @description 渲染表格时有尾列时，清除右边灰色区域，防止表格有值溢出
 */
function handleCellOverflow(tableCtx, drawParams) {
    const { scrollWidth, scrollHeight, offsetLeft, offsetTop, dataset_col_ed, fill_col_ed, fill_row_ed } = drawParams;

    if (dataset_col_ed != Store.visibledatacolumn.length - 1) return;

    tableCtx.clearRect(
        fill_col_ed - scrollWidth + offsetLeft - 1,
        offsetTop - 1,
        Store.ch_width - Store.visibledatacolumn[dataset_col_ed],
        fill_row_ed - scrollHeight,
    );
}

/**
 * @description 解析合并单元格数据
 */
function parseMergeCellData(cellupdate) {
    const mergeCellData = [];

    // 这里取值可能有异常 待定
    for (let cell of cellupdate) {
        const { r, c } = cell;
        const mergeCell = Store.flowdata[r][c];
        if (!mergeCell) continue;

        if (typeof mergeCell == "object" && "mc" in mergeCell) {
            mergeCellData.push(cell);
        }
    }

    return mergeCellData;
}

/**
 * @description 辅助函数 - 绘制单元格边框 这个不是 border Info 属性的边框，而是页面上单元格的边框
 */
function drawCellBorder(tableCtx, moveX, moveY, lineX, lineY, color) {
    tableCtx.beginPath();
    tableCtx.moveTo(moveX, moveY);
    tableCtx.lineTo(lineX, lineY);
    tableCtx.lineWidth = 0.75;
    // 这里绘制的颜色是需要区分的，如果是‘护眼模式’，则使用 '#c2c2c2' 不然使用 '#d4d4d4',不然看不见线条
    tableCtx.strokeStyle = handleCellBorderColor(color);
    tableCtx.stroke();
    tableCtx.closePath();
}

/** 配合实现具体边框的绘制 */
function drawBorder(canvas, borderInfo, m_st, m_ed, line_st, line_ed, hv) {
    const { style, color } = borderInfo;
    canvas.save();
    menuButton.setLineDash(canvas, style, hv, m_st, m_ed, line_st, line_ed);
    canvas.strokeStyle = color;
    canvas.stroke();
    canvas.closePath();
    canvas.restore();
}

/**
 * @description 对传入的边框单元格，获取其真实的行列坐标，以达到合并单元格绘制一条斜线的效果
 */
function getSlashMergeCell(bd_r, bd_c, start_r, start_c, end_r, end_c, scrollHeight, scrollWidth) {
    // 定义原始数据，如果没有合并单元格，直接返回
    const originalData = { sr: start_r, sc: start_c, er: end_r, ec: end_c };

    // 传入的 行列是边框所在的单元格
    let cell = Store.flowdata[bd_r] && Store.flowdata[bd_r][bd_c];
    if (cell == null) return originalData;

    // 判断是否是合并单元格，是的话，重新计算开始结束行列
    if (getObjType(cell) == "object" && "mc" in cell) {
        let mc = cell.mc;
        // return { r: mc.r, c: mc.c, rs: mc.rs, cs: mc.cs };
        let start_c = mc.c == 0 ? 0 : Store.visibledatacolumn[mc.c - 1] - scrollWidth;
        let start_r = mc.r == 0 ? -scrollHeight - 1 : Store.visibledatarow[mc.r - 1] - scrollHeight - 1;
        let end_c = Store.visibledatacolumn[mc.c + mc.cs - 1] - scrollWidth;
        let end_r = Store.visibledatarow[mc.r + mc.rs - 1] - scrollHeight;

        return { sr: start_r, sc: start_c, er: end_r, ec: end_c };
    } else return originalData;
}
/**
 * @description 辅助函数 - 重叠两个颜色,并且以颜色1为主,颜色2为辅
 * @param {*} mainColor 颜色1
 * @param {*} overlayColor 颜色2
 * @returns 重叠后的颜色
 */
function overlayColors(mainColor, overlayColor) {
    const parseColor = (color) => {
        if (!color) return { r: 255, g: 255, b: 255, a: 1 };

        if (color.startsWith("#")) {
            let hex = color.replace("#", "");
            if (hex.length === 3) {
                hex = hex
                    .split("")
                    .map((c) => c + c)
                    .join("");
            }
            return {
                r: parseInt(hex.substr(0, 2), 16),
                g: parseInt(hex.substr(2, 2), 16),
                b: parseInt(hex.substr(4, 2), 16),
                a: 1,
            };
        } else if (color.startsWith("rgb")) {
            const values = color.match(/[\d.]+/g);
            return {
                r: parseInt(values[0]),
                g: parseInt(values[1]),
                b: parseInt(values[2]),
                a: values.length === 4 ? parseFloat(values[3]) : 1,
            };
        }
        return { r: 255, g: 255, b: 255, a: 1 };
    };

    const main = parseColor(mainColor);
    const overlay = parseColor(overlayColor);

    const overlayAlpha = overlay.a || 0.5;

    const r = Math.round(main.r * (1 - overlayAlpha) + overlay.r * overlayAlpha);
    const g = Math.round(main.g * (1 - overlayAlpha) + overlay.g * overlayAlpha);
    const b = Math.round(main.b * (1 - overlayAlpha) + overlay.b * overlayAlpha);

    return `rgb(${r}, ${g}, ${b})`;
}

/**
 * @description 绘制网格行标题
 */
function luckysheetDrawgridRowTitle(scrollHeight, drawHeight, offsetTop) {
    // 参数未定义兼容处理
    if (scrollHeight == null) scrollHeight = $("#luckysheet-cell-main").scrollTop();
    if (drawHeight == null) drawHeight = Store.luckysheetTableContentHW[1];
    if (offsetTop == null) offsetTop = Store.columnHeaderHeight;

    let ctx = $("#luckysheetTableContent").get(0).getContext("2d");
    ctx.save();
    ctx.scale(Store.devicePixelRatio, Store.devicePixelRatio);
    ctx.clearRect(0, offsetTop, Store.rowHeaderWidth - 1, drawHeight);

    ctx.font = luckysheetdefaultFont();
    ctx.textBaseline = luckysheetdefaultstyle.textBaseline; //基准线 垂直居中
    ctx.fillStyle = luckysheetdefaultstyle.fillStyle;

    let dataset_row_st, dataset_row_ed;
    dataset_row_st = luckysheet_searcharray(Store.visibledatarow, scrollHeight);
    dataset_row_ed = luckysheet_searcharray(Store.visibledatarow, scrollHeight + drawHeight);

    if (dataset_row_st == -1) {
        dataset_row_st = 0;
    }
    if (dataset_row_ed == -1) {
        dataset_row_ed = Store.visibledatarow.length - 1;
    }

    ctx.save();
    ctx.beginPath();
    ctx.rect(0, offsetTop - 1, Store.rowHeaderWidth - 1, drawHeight - 2);
    ctx.clip();

    let preEndR;
    for (let r = dataset_row_st; r <= dataset_row_ed; r++) {
        const start_r = !r ? -scrollHeight - 1 : Store.visibledatarow[r - 1] - scrollHeight - 1;

        const end_r = Store.visibledatarow[r] - scrollHeight;

        let firstOffset = dataset_row_st == r ? -2 : 0;
        let lastOffset = dataset_row_ed == r ? -2 : 0;

        //列标题单元格渲染前触发，return false 则不渲染该单元格
        if (
            !method.createHookFunction(
                "rowTitleCellRenderBefore",
                r + 1,
                {
                    r: r,
                    top: start_r + offsetTop + firstOffset,
                    width: Store.rowHeaderWidth - 1,
                    height: end_r - start_r + 1 + lastOffset - firstOffset,
                },
                ctx,
            )
        ) {
            continue;
        }

        if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) {
        } else {
            // 背景颜色
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, start_r + offsetTop + firstOffset, Store.rowHeaderWidth - 1, end_r - start_r + 1 + lastOffset - firstOffset);

            //行标题栏序列号
            ctx.save(); //save scale before draw text
            ctx.scale(Store.zoomRatio, Store.zoomRatio);
            let textMetrics = getMeasureText(r + 1, ctx);
            //ctx.measureText(r + 1);

            let horizonAlignPos = (Store.rowHeaderWidth - textMetrics.width) / 2;
            let verticalAlignPos = start_r + (end_r - start_r) / 2 + offsetTop;

            ctx.fillStyle = "#000000";
            ctx.fillText(r + 1, horizonAlignPos / Store.zoomRatio, verticalAlignPos / Store.zoomRatio);
            ctx.restore(); //restore scale after draw text
        }

        //vertical
        ctx.beginPath();
        ctx.moveTo(Store.rowHeaderWidth - 2, start_r + offsetTop - 2);
        ctx.lineTo(Store.rowHeaderWidth - 2, end_r + offsetTop - 2);
        ctx.lineWidth = 0.5;

        ctx.strokeStyle = luckysheetdefaultstyle.strokeStyle;
        ctx.stroke();
        ctx.closePath();

        //行标题栏横线,horizen
        if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] == null && Store.config["rowhidden"][r + 1] != null) {
            ctx.beginPath();
            ctx.moveTo(-1, end_r + offsetTop - 4);
            ctx.lineTo(Store.rowHeaderWidth - 1, end_r + offsetTop - 4);
            ctx.closePath();
            ctx.stroke();
        } else if (Store.config["rowhidden"] == null || Store.config["rowhidden"][r] == null) {
            ctx.beginPath();
            ctx.moveTo(-1, end_r + offsetTop - 2);
            ctx.lineTo(Store.rowHeaderWidth - 1, end_r + offsetTop - 2);
            ctx.closePath();
            ctx.stroke();
        }

        if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r - 1] != null && preEndR != null) {
            ctx.beginPath();
            ctx.moveTo(-1, preEndR + offsetTop);
            ctx.lineTo(Store.rowHeaderWidth - 1, preEndR + offsetTop);
            ctx.closePath();
            ctx.stroke();
        }

        preEndR = end_r;

        //列标题单元格渲染前触发，return false 则不渲染该单元格
        method.createHookFunction(
            "rowTitleCellRenderAfter",
            r + 1,
            {
                r: r,
                top: start_r + offsetTop + firstOffset,
                width: Store.rowHeaderWidth - 1,
                height: end_r - start_r + 1 + lastOffset - firstOffset,
            },
            ctx,
        );
    }
    ctx.restore();
    ctx.restore();
}

/**
 * @description 绘制网格列标题
 */
function luckysheetDrawgridColumnTitle(scrollWidth, drawWidth, offsetLeft) {
    if (scrollWidth == null) scrollWidth = $("#luckysheet-cell-main").scrollLeft();
    if (drawWidth == null) drawWidth = Store.luckysheetTableContentHW[0];
    if (offsetLeft == null) offsetLeft = Store.rowHeaderWidth;

    let ctx = $("#luckysheetTableContent").get(0).getContext("2d");
    ctx.save();
    ctx.scale(Store.devicePixelRatio, Store.devicePixelRatio);
    ctx.clearRect(offsetLeft, 0, drawWidth, Store.columnHeaderHeight - 1);

    ctx.font = luckysheetdefaultFont();
    ctx.textBaseline = luckysheetdefaultstyle.textBaseline; //基准线 垂直居中
    ctx.fillStyle = luckysheetdefaultstyle.fillStyle;

    let dataset_col_st, dataset_col_ed;
    dataset_col_st = luckysheet_searcharray(Store.visibledatacolumn, scrollWidth);
    dataset_col_ed = luckysheet_searcharray(Store.visibledatacolumn, scrollWidth + drawWidth);

    if (dataset_col_st == -1) dataset_col_st = 0;
    if (dataset_col_ed == -1) dataset_col_ed = Store.visibledatacolumn.length - 1;

    ctx.save();
    ctx.beginPath();
    ctx.rect(offsetLeft, 0, drawWidth, Store.columnHeaderHeight);
    ctx.clip();

    // console.log(offsetLeft, 0, drawWidth, Store.columnHeaderHeight -1);

    let preEndC;
    for (let c = dataset_col_st; c <= dataset_col_ed; c++) {
        const start_c = !c ? -scrollWidth : Store.visibledatacolumn[c - 1] - scrollWidth;
        const end_c = Store.visibledatacolumn[c] - scrollWidth;

        //若超出绘制区域终止
        // if(end_c > scrollWidth + drawWidth+1){
        //     break;
        // }
        let abc = chatatABC(c);
        //列标题单元格渲染前触发，return false 则不渲染该单元格
        if (
            !method.createHookFunction(
                "columnTitleCellRenderBefore",
                abc,
                {
                    c: c,
                    left: start_c + offsetLeft,
                    width: end_c - start_c,
                    height: Store.columnHeaderHeight,
                },
                ctx,
            )
        ) {
            continue;
        }

        if (Store.config["colhidden"] != null && Store.config["colhidden"][c] != null) {
        } else {
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(start_c + offsetLeft, 0, end_c - start_c, Store.columnHeaderHeight);

            //列标题栏序列号
            ctx.save(); //save scale before draw text
            ctx.scale(Store.zoomRatio, Store.zoomRatio);

            let textMetrics = getMeasureText(abc, ctx);
            //ctx.measureText(abc);

            let horizonAlignPos = Math.round(start_c + (end_c - start_c) / 2 + offsetLeft - textMetrics.width / 2);
            let verticalAlignPos = Math.round(Store.columnHeaderHeight / 2);
            ctx.fillStyle = "#000000";
            ctx.fillText(abc, horizonAlignPos / Store.zoomRatio, verticalAlignPos / Store.zoomRatio);
            ctx.restore(); //restore scale after draw text
        }

        //列标题栏竖线 vertical
        if (Store.config["colhidden"] != null && Store.config["colhidden"][c] == null && Store.config["colhidden"][c + 1] != null) {
            ctx.beginPath();
            ctx.moveTo(end_c + offsetLeft - 4, 0);
            ctx.lineTo(end_c + offsetLeft - 4, Store.columnHeaderHeight - 2);
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = luckysheetdefaultstyle.strokeStyle;
            ctx.closePath();
            ctx.stroke();
        } else if (Store.config["colhidden"] == null || Store.config["colhidden"][c] == null) {
            ctx.beginPath();
            ctx.moveTo(end_c + offsetLeft - 2, 0);
            ctx.lineTo(end_c + offsetLeft - 2, Store.columnHeaderHeight - 2);
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = luckysheetdefaultstyle.strokeStyle;
            ctx.closePath();
            ctx.stroke();
        }

        if (Store.config["colhidden"] != null && Store.config["colhidden"][c - 1] != null && preEndC != null) {
            ctx.beginPath();
            ctx.moveTo(preEndC + offsetLeft, 0);
            ctx.lineTo(preEndC + offsetLeft, Store.columnHeaderHeight - 2);
            ctx.closePath();
            ctx.stroke();
        }

        //horizen
        ctx.beginPath();
        ctx.moveTo(start_c + offsetLeft - 1, Store.columnHeaderHeight - 2);
        ctx.lineTo(end_c + offsetLeft - 1, Store.columnHeaderHeight - 2);
        ctx.stroke();
        ctx.closePath();

        preEndC = end_c;

        method.createHookFunction(
            "columnTitleCellRenderAfter",
            abc,
            {
                c: c,
                left: start_c + offsetLeft - 1,
                width: end_c - start_c,
                height: Store.columnHeaderHeight - 1,
            },
            ctx,
        );
    }

    // Must be restored twice, otherwise it will be enlarged under window.devicePixelRatio = 1.5
    ctx.restore();
    ctx.restore();
}

/**
 * @description 处理单元格背景颜色
 */
function handleFillStyle(fillStyle, r, c) {
    const { highlight, eyeMode = false, highlightColor, eyeModeFill } = Store.visualAidOptions;
    const needHighlight = highlightCellCtrl.needHighlight(r, c);

    // 如果当前单元格需要高亮
    if (needHighlight && highlight) {
        // 判断是否为护眼模式
        const originColor = eyeMode ? eyeModeFill : "";
        return highlightCellCtrl.blendColors(fillStyle || originColor, highlightColor);
    }

    // 如果不需要高亮的单元格，则判定是否为护眼模式，直接处理返回颜色即可
    if (fillStyle) return fillStyle;
    return eyeMode ? eyeModeFill : "#ffffff";
}

/**
 * @description 处理单元格的绘制颜色
 */
function handleCellBorderColor(color) {
    if (color) return color;

    // 判定是否为护眼模式
    const { eyeMode = false, eyeModeBorderColor } = Store.visualAidOptions;

    return eyeMode ? eyeModeBorderColor : luckysheetdefaultstyle.strokeStyle;
}

export {
    parseDrawContext,
    getRenderAreaRange,
    parseCellData,
    cellOverflow_colIn,
    getCellOverflowMap,
    handleCellOverflow,
    parseMergeCellData,
    drawCellBorder,
    initCanvas,
    drawBorder,
    getSlashMergeCell,
    overlayColors,
    luckysheetDrawgridRowTitle,
    luckysheetDrawgridColumnTitle,
    handleFillStyle,
};
